"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareItems = exports.extractItemsControlsVisibility = exports.extractItemClasses = exports.extractItemParams = exports.shiftValues = exports.copyItems = exports.removeIndexes = exports.updateItem = exports.addItem = exports.removeItem = exports.moveItem = void 0;

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _pullAt = _interopRequireDefault(require("lodash/pullAt"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _classnames = _interopRequireDefault(require("classnames"));

var _value = require("../../skybase-core/utils/value");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HIDDEN = _constants.itemControls.HIDDEN,
    DISABLED = _constants.itemControls.DISABLED;
/**
 * @desc
 * Moves given item to given direction in the list, by swapping it with the nearest item in this direction.
 *
 * @param items
 * @param item
 * @param direction
 * @returns {*}
 */

var moveItem = function moveItem(_ref) {
  var items = _ref.items,
      item = _ref.item,
      direction = _ref.direction;
  var index = item.index,
      value = item.value; // Sort items in array by 'index' property to see real order.

  var sortedItems = (0, _sortBy.default)(items, function (i) {
    return i.index;
  }); // Find position of our item by its value.

  var itemPosition = (0, _findIndex.default)(sortedItems, function (i) {
    return i.value === value;
  }); // Calculate boundary index in given direction.

  var boundaryIndex = direction === _constants.actions.MOVEUP ? 0 : items.length - 1;

  if (itemPosition === boundaryIndex) {
    // Do nothing, item already reached its boundary.
    return items;
  } // Find the nearest array element.


  var nearestElementIndex = itemPosition + (direction === _constants.actions.MOVEUP ? -1 : 1);
  var secondItem = sortedItems[nearestElementIndex]; // Swap indexes of these two items.

  sortedItems[itemPosition].index = secondItem.index;
  sortedItems[nearestElementIndex].index = index;
  return sortedItems;
};
/**
 * @desc
 * Removes given item from the list and re-indexes resulting list.
 *
 * @param items
 * @param item
 */


exports.moveItem = moveItem;

var removeItem = function removeItem(_ref2) {
  var items = _ref2.items,
      item = _ref2.item;
  var value = item.value; // Sort items in array by 'index' property to see real order.

  var sortedItems = (0, _sortBy.default)(items, function (i) {
    return i.index;
  }); // Find position of our item by its value.

  var itemPosition = (0, _findIndex.default)(sortedItems, function (i) {
    return i.value === value;
  }); // Remove it.

  (0, _pullAt.default)(sortedItems, itemPosition); // Reindex all indexes by current order.

  sortedItems.forEach(function (i, index) {
    i.index = index;
  });
  return sortedItems;
};
/**
 * @desc
 * Adds empty item to the end of items list.
 *
 * @param items
 * @param value
 * @returns {*}
 */


exports.removeItem = removeItem;

var addItem = function addItem(_ref3) {
  var items = _ref3.items,
      value = _ref3.value;
  // Find the highest index from given items.
  var highestIndex = items.length;
  return items.concat({
    value: value,
    index: highestIndex
  });
};
/**
 * @desc
 * Updates value of given item.
 *
 * @param items
 * @param item
 * @param newValue
 * @returns {*}
 */


exports.addItem = addItem;

var updateItem = function updateItem(_ref4) {
  var positionIndex = _ref4.positionIndex,
      allItems = _ref4.allItems,
      newValue = _ref4.newValue;
  return allItems.map(function (iteratingItem) {
    if (iteratingItem.positionIndex === positionIndex) {
      return _objectSpread(_objectSpread({}, iteratingItem), {}, {
        value: newValue
      });
    }

    return iteratingItem;
  });
};
/*
Purifies returning items from internal variable positionIndex
 */


exports.updateItem = updateItem;

var removeIndexes = function removeIndexes(items) {
  return items.map(function (item) {
    var positionIndex = item.positionIndex,
        rest = _objectWithoutProperties(item, ["positionIndex"]);

    return _objectSpread({}, rest);
  });
};
/*
Creates an item from props
 */


exports.removeIndexes = removeIndexes;

var createItem = function createItem(item, i) {
  var positionIndex = item.positionIndex,
      rest = _objectWithoutProperties(item, ["positionIndex"]);

  return _objectSpread(_objectSpread({}, rest), {}, {
    positionIndex: i
  });
};
/*
Creates a copy of given items (from props) and sorts them
 */


var copyItems = function copyItems(items) {
  return (0, _sortBy.default)(items.map(function (item, i) {
    return createItem(item, i);
  }), function (item) {
    return item.positionIndex;
  });
};
/*
Moves first item into the position of the second item and shift all items between.
Each of the items (allItems) still has its own positionValue before and after this function.
 */


exports.copyItems = copyItems;

var shiftValues = function shiftValues(_ref5) {
  var allItems = _ref5.allItems,
      item1 = _ref5.item1,
      item2 = _ref5.item2;
  var newPosition1 = item2.positionIndex;
  var doing = false;
  var acc = item1.positionIndex < item2.positionIndex ? -1 : 1;
  return allItems.map(function (item) {
    if (item.positionIndex === item1.positionIndex) {
      doing = !doing;
      return _objectSpread(_objectSpread({}, item), {}, {
        positionIndex: newPosition1
      });
    }

    if (item.positionIndex === item2.positionIndex) {
      doing = !doing;
      return _objectSpread(_objectSpread({}, item), {}, {
        positionIndex: item.positionIndex + acc
      });
    }

    if (doing) {
      item.positionIndex += acc;
    }

    return item;
  });
};
/*
Extracts some options from the item for rendering use.
 */


exports.shiftValues = shiftValues;

var extractItemParams = function extractItemParams(options) {
  var item = options.item,
      allItems = options.allItems,
      id = options.id;
  var positionIndex = item.positionIndex;
  var isLast = allItems[allItems.length - 1].positionIndex === positionIndex;
  var upButtonId = id ? "".concat(id, "-upButton-").concat(positionIndex) : null;
  var downButtonId = id ? "".concat(id, "-downButton-").concat(positionIndex) : null;
  var removeButtonId = id ? "".concat(id, "-removeButton-").concat(positionIndex) : null;
  return {
    isLast: isLast,
    upButtonId: upButtonId,
    downButtonId: downButtonId,
    removeButtonId: removeButtonId
  };
};
/*
Extracts some classNames from the item for rendering use.
 */


exports.extractItemParams = extractItemParams;

var extractItemClasses = function extractItemClasses(options) {
  var item = options.item,
      draggingItem = options.draggingItem,
      positionIndex = options.positionIndex,
      allItems = options.allItems,
      isMovingClassName = options.isMovingClassName,
      isArrowDisabled = options.isArrowDisabled,
      isRemoveDisabled = options.isRemoveDisabled;
  var className = item.className;
  var isMoving = !(0, _value.isNullOrUndefined)(draggingItem) && positionIndex === draggingItem.positionIndex;
  var itemClass = (0, _classnames.default)('fl-row', className, _defineProperty({}, isMovingClassName, isMoving));
  var moveUpClass = positionIndex !== 0 && !isArrowDisabled ? 'item-control sbi-triangle-up' : (0, _classnames.default)('item-control sbi-triangle-up', _constants.DISABLED_ITEM_CLASS);
  var moveDownClass = positionIndex !== allItems.length - 1 && !isArrowDisabled ? 'item-control sbi-triangle-down' : (0, _classnames.default)('item-control sbi-triangle-down', _constants.DISABLED_ITEM_CLASS);
  var deleteClass = !isRemoveDisabled ? 'item-control sbi-trash-filled item-control-large' : (0, _classnames.default)('item-control sbi-trash-filled item-control-large', _constants.DISABLED_ITEM_CLASS);
  return {
    itemClass: itemClass,
    moveUpClass: moveUpClass,
    moveDownClass: moveDownClass,
    deleteClass: deleteClass
  };
};
/*
Sets the visibility (disability) of controls for ALL items.
 */


exports.extractItemClasses = extractItemClasses;

var extractItemsControlsVisibility = function extractItemsControlsVisibility(_ref6) {
  var disabled = _ref6.disabled,
      arrows = _ref6.arrows,
      remove = _ref6.remove;
  var isArrowHidden = false;
  var isRemoveHidden = false;
  var isArrowDisabled = disabled || false; // in case of undefined

  if (arrows) {
    var formattedArrow = arrows.toLowerCase();
    isArrowDisabled = formattedArrow === DISABLED;
    isArrowHidden = formattedArrow === HIDDEN;
  }

  var isRemoveDisabled = disabled;

  if (remove) {
    var formattedRemove = remove.toLowerCase();
    isRemoveDisabled = formattedRemove === DISABLED;
    isRemoveHidden = formattedRemove === HIDDEN;
  }

  return {
    isArrowDisabled: isArrowDisabled,
    isArrowHidden: isArrowHidden,
    isRemoveDisabled: isRemoveDisabled,
    isRemoveHidden: isRemoveHidden
  };
}; // extracts positionIndexes from the `prevItems` (basically state) and then compares it with `nextItems` (basically props).


exports.extractItemsControlsVisibility = extractItemsControlsVisibility;

var compareItems = function compareItems(_ref7) {
  var prevItems = _ref7.prevItems,
      nextItems = _ref7.nextItems;
  var items = [];
  prevItems.forEach(function (item) {
    var positionIndex = item.positionIndex,
        rest = _objectWithoutProperties(item, ["positionIndex"]);

    items.push(_objectSpread({}, rest));
  });
  return (0, _isEqual.default)(items, nextItems);
};

exports.compareItems = compareItems;
//# sourceMappingURL=utils.js.map